import { z } from "zod";
import type { infer as zInfer } from "zod";

export const skrillDeposit = z.object({
  amount: z.number(),
  currency: z.string(),
  firstTime: z.boolean(),
  sid: z.string(),
  skrillEmail: z.string(),
  status: z.enum([
    "PROCESSED",
    "AWAITING_RESPONSE",
    "PENDING",
    "CANCELLED",
    "FAILED",
    "CHARGE_BACK",
  ]),
  transactionId: z.string(),
});

export type SkrillDeposit = zInfer<typeof skrillDeposit>;
